import "./MultiAccountEquityOrderConfirmStep.scss";
import template from "./MultiAccountEquityOrderConfirmStep.html";
import {IFormController, IOnDestroy, IOnInit} from "angular";
import {OrderVettingService} from "../../../services/OrderVettingService";
import {Observable, ReplaySubject} from "rxjs";
import {isNotNull} from "../../../../../../js/util/UtilFunctions";
import {OrderVettingResponse, VettingOutcomes} from "../../../types/OrderVettingResponse";
import {extractOrderRequest} from "../../util/MultiAccountEquityWizardOrderUtil";
import {MultiOrderStore} from "../../store/MultiOrderStore";
import {EquityWizardData} from "../../../place-equity-order-wizard/models/EquityWizardData";

export const MultiAccountEquityOrderConfirm = "tfMultiAccountEquityOrderConfirmStep";

export function multiAccountEquityOrderConfirm() {
    return {
        template,
        bindings: {
            store: "<"
        },
        controller: EquityOrderConfirmStepController,
        controllerAs: "ctrl"
    };
}

export class EquityOrderConfirmStepController implements IOnInit, IOnDestroy {

    /** @input */
    public readonly store: MultiOrderStore;

    /** @ui-binding */
    public set vettingForm(form: IFormController | null) {
        if (form != null) {
            this.vettingForm$.next(form);
        }
    }

    private readonly vettingForm$ = new ReplaySubject<IFormController>(1);

    public readonly order$ = new ReplaySubject<EquityWizardData[]>(1);
    public readonly vettingResponse$ = new ReplaySubject<OrderVettingResponse[]>(1);
    public readonly vettingOutcomes$: Observable<VettingOutcomes[]>;

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor(private readonly orderVettingService: OrderVettingService) {
        this.vettingOutcomes$ = this.vettingResponse$
                                    .map((r) => r.map(v => v.vettingOutcomes));

        const hasValidationErrors =
            this.vettingOutcomes$
                .map((r) => r.every( value => value.errors));
        const validationSource = Observable.combineLatest(hasValidationErrors, this.vettingForm$);

        validationSource.takeUntil(this.destroyed$)
                        .subscribe(([hasErrors, form]) => this.updateValidation(hasErrors, form));
    }

    public async $onInit(): Promise<void> {
        this.watchOrder();
        this.watchVettingChanges();
    }

    private watchOrder() {
        this.store
            .orders$
            .takeUntil(this.destroyed$)
            .subscribe((order) => this.order$.next(order));
    }

    private watchVettingChanges() {
        this.store
            .orders$
            .takeUntil(this.destroyed$)
            .distinctUntilChanged((a, b) => (a === b))
            .map((d) => extractOrderRequest(d))
            .filter(isNotNull)
            .switchMap((order) => this.orderVettingService.validateMultiAccount(order?.orders))
            .subscribe((response) => {
                this.vettingResponse$.next(response);
            });
    }

    private updateValidation(hasErrors: boolean, form: IFormController) {
        form.$setValidity("vetting-errors", true, form);
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
